module.exports = __webpack_public_path__ + "static/media/blue-loader.f5459d3a.svg";